import api from 'api';

export const loadChartApi = api('POST /api/hourly-tracker/chart');
export const loadChartMetrics = api('GET /api/hourly-tracker/chart/metrics');
export const loadChart = async (params) => await loadChartApi(params);
